import Vue from 'vue'

import uiTextEditor from './src/ui-text-editor.vue';

Vue.component('ui-text-editor', uiTextEditor);

export default uiTextEditor;



//////////////////
// WEBPACK FOOTER
// ./~/ui-text-editor/index.js
// module id = 561
// module chunks = 0